module.exports = __webpack_public_path__ + "static/media/umbrella_logo_white_letters_small_blue.1dfbb7dc.png";